export default __webpack_public_path__ + "static/media/ca.259890dc.svg";